import React from "react";
import {
  ButtonContainer,
  SignUpBtn,
  ShopBtn,
  HeroContainer,
  HeroHeading,
  HeroTagline,
  HeroTextContainer,
} from "./HeroStyles";

const Hero = () => {
  return (
    <HeroContainer>
      <div>
        <HeroTextContainer>
          <HeroTagline>Connecting farmers to buyers</HeroTagline>
          <HeroHeading>
            You Grow.<span>We connect</span>
          </HeroHeading>
        </HeroTextContainer>
        <ButtonContainer>
          {/* <ShopBtn to="#vegetables">Shop now</ShopBtn> */}
          <SignUpBtn to="/login">Become a seller</SignUpBtn>
        </ButtonContainer>
      </div>
    </HeroContainer>
  );
};

export default Hero;
